type Props = {
  value: any;
};

export const BackNumberCellElem = ({ value }: Props) => {
  return (
    <td style={{ alignItems: 'center' }}>
      <div>{value}</div>
    </td>
  );
};
